import React from 'react';

import s from './SRLStackedTooltip.module.css';

const SRLStackedTooltip = ({ payload, triangleOffset,  children }) => (
  <div className={s.container} >
    <div className={s.triangle} style={{ left: triangleOffset ? `calc(50% + ${triangleOffset}px)` : '50%' }}/>
    <div className={s.contentContainer}>
      {children  && children(payload)}
    </div>
  </div>
);

export default React.memo(SRLStackedTooltip);
